import { render } from "./FileDetailsDialog.vue?vue&type=template&id=7294679c&scoped=true"
import script from "./FileDetailsDialog.vue?vue&type=script&lang=js"
export * from "./FileDetailsDialog.vue?vue&type=script&lang=js"

import "./FileDetailsDialog.vue?vue&type=style&index=0&id=7294679c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7294679c"]])

export default __exports__